<script setup lang="ts">
  interface Props {
    maxWidth?: number
    height?: number
  }
  const props = withDefaults(defineProps<Props>(), {
    maxWidth: 158,
    height: 20,
  })
</script>

<template>
  <div
    class="skeleton-atom"
    :style="{ maxWidth: `${props.maxWidth}px`, height: `${props.height}px` }"
  ></div>
</template>

<style scoped lang="scss">
  .skeleton-atom {
    width: 100vw;
    border-radius: var(--radius-2);
    background: linear-gradient(
      90deg,
      var(--colorBgSrfTertiaryAlpha) 25%,
      var(--colorAlphaPurple12) 50%,
      var(--colorBgSrfTertiaryAlpha) 75%
    );
    background-size: 200% 100%;
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
</style>
